import { Field, Label } from "../ui-components/fieldset.tsx";
import { Input } from "../ui-components/input.tsx";
import { FC, memo } from "react";
import { Text } from "../ui-components/text.tsx";
import SearchIcon from "../assets/images/search.svg";
import clsx from "clsx";
import { FieldConfig, FieldInputProps } from "formik";

interface ITextFieldCustom {
    label?: string | React.ReactNode;
    placeholder: string;
    getFieldMeta?: (name: string) => { error?: string; touched?: boolean };
    text?: string;
    search?: boolean;
    centerText?: boolean;
    formikValue?: string;
    handleUsernameBlur?: () => void;
    getFieldProps?: <Value = any>(props: string | FieldConfig<Value>) => FieldInputProps<Value>;
}

export const TextFieldCustom: FC<ITextFieldCustom> = memo(
    ({
         getFieldProps,
         getFieldMeta,
         formikValue,
         label,
         handleUsernameBlur,
         placeholder,
         text,
         search,
         centerText,
     }) => {
        const field = getFieldProps && formikValue ? getFieldProps(formikValue) : undefined;
        const meta = getFieldMeta && formikValue ? getFieldMeta(formikValue) : undefined;
        // Показываем ошибку только если поле было затронуто (touched) и в нём есть текст ошибки
        const isError = !!(meta?.touched && meta?.error);

        return (
            <Field className="relative">
                {label && (
                    <Label className="text-[var(--text-color-dark)] text-[14px] leading-[20px] mb-2 block !font-semibold">
                        {label}
                    </Label>
                )}

                {search && <SearchIcon className="absolute z-40 w-6 h-6 left-[15px] top-[35px]" />}

                <Input
                    {...field}
                    name={formikValue}
                    // Важно: используем именно field.onBlur, чтобы Formik пометил поле как touched
                    onBlur={(e) => {
                        field?.onBlur(e);
                        handleUsernameBlur?.();
                    }}
                    className={clsx(
                        "[&>input]:!bg-white [&>input]:!border [&>input]:!border-[var(--border-color-block)] [&>input]:!text-sm [&>input]:px-[12px] [&>input]:py-[7px] inputShadow !mt-0",
                        {
                            "[&>input]:pl-[48px]": search,
                            "[&>input]:!text-center": centerText,
                            "[&>input]:!border-red-500 mb-[28px]": isError,
                        }
                    )}
                    placeholder={placeholder}
                />

                {isError && (
                    <Text className="!text-xs !text-red-500 mt-2 absolute left-0 bottom-[-18px]">
                        {meta?.error}
                    </Text>
                )}

                {text && !isError && (
                    <Text className="!text-sm text-[var(--color-secondary)] mt-2">{text}</Text>
                )}
            </Field>
        );
    }
);
